import { Icon } from '@components/primitives/Icon'
import { classMerge } from '@components/utilities/classMerge'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import type { BackgroundColor, TextColor } from '@lib/colors/colors'

export function DetailPill({
  bgColor,
  className,
  icon,
  iconColor,
  prefix,
  value,
}: {
  bgColor?: BackgroundColor
  className?: string
  icon?: IconDefinition
  iconColor?: TextColor
  prefix?: string
  value?: string
}) {
  if (!value) {
    return null
  }

  return (
    <div
      className={classMerge(
        'flex items-center whitespace-nowrap rounded-full bg-primary100/50 py-0.5',
        className,
        bgColor,
      )}
      title={value}
    >
      {icon && (
        <Icon className={classMerge('ml-2', iconColor)} icon={icon} size='xs' />
      )}
      {prefix && (
        <span
          className={classMerge(
            'ml-1 text-nowrap text-xs leading-normal antialiased',
            !icon && 'ml-2',
          )}
        >
          {`${prefix}:`}
        </span>
      )}
      <span
        className={classMerge(
          'mr-2 max-w-44 truncate text-nowrap pl-0.5 text-xs font-semibold leading-normal antialiased',
          !prefix && 'ml-2',
        )}
        title={value}
      >
        {value}
      </span>
    </div>
  )
}
